import { render, staticRenderFns } from "./SharingBtn.vue?vue&type=template&id=03baac98&scoped=true&"
var script = {}
import style0 from "./SharingBtn.vue?vue&type=style&index=0&id=03baac98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03baac98",
  null
  
)

export default component.exports